"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _glamor = require("glamor");

var _reactGoogleRecaptcha = require("react-google-recaptcha");

var _reactGoogleRecaptcha2 = _interopRequireDefault(_reactGoogleRecaptcha);

var _config = require("config");

var _config2 = _interopRequireDefault(_config);

var _css = require("@quixeltools/quixel-ui-library/dist/utils/css");

var _fonts = require("@quixeltools/quixel-ui-library/dist/utils/fonts");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var inputLabel = (0, _glamor.css)(_fonts.subH4, {
  display: "block",
  color: _css.pallets.gray_text,
  textTransform: "uppercase",
  marginBottom: (0, _css.unitRem)(0.25)
});

var errorCss = (0, _glamor.css)({
  position: "absolute",
  display: "block",

  marginTop: "0.4rem",

  fontSize: "0.9375rem",
  fontWeight: "400",

  color: _css.pallets.red
});

function Captcha(props) {
  var field = props.field,
      onChange = props.onChange;

  var hasError = field.touched && field.error;

  var handleChange = function handleChange(value) {
    field.onChange(value);

    if (onChange) {
      onChange(value);
    }
  };

  return _react2.default.createElement(
    "div",
    { className: (0, _glamor.css)({ marginBottom: 36, marginTop: 42 }) },
    _react2.default.createElement(
      "div",
      { className: inputLabel },
      "Are you human?"
    ),
    _react2.default.createElement(_reactGoogleRecaptcha2.default, {
      size: "normal",
      sitekey: _config2.default.captchaKey,
      theme: "dark",
      onChange: handleChange
    }),
    hasError ? _react2.default.createElement(
      "div",
      { className: errorCss },
      field.error
    ) : null
  );
}

exports.default = Captcha;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/Captcha/Captcha.jsx
// module id = 2557
// module chunks = 0